import { useState } from 'react';
import { useDeleteQuoteGroup } from '../../api/useDeleteQuoteGroup';

type Props = {
  groupId: string;
  afterDeletion?: () => void;
};

export function useQuoteGroupMenuAction(props: Props) {
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const { mutateAsync } = useDeleteQuoteGroup();

  async function handleConfirmDelete() {
    await mutateAsync(props.groupId);
    props.afterDeletion?.();
  }

  return {
    isDeleteOpen,
    handleOpenDelete: () => setIsDeleteOpen(true),
    handleCloseDelete: () => setIsDeleteOpen(false),
    handleConfirmDelete,
  };
}
